import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

import importScript from "../../hooks/importScript";
import {
  BasicNumericInputShape,
  NumericInputShape,
} from "../../interfaces/componentTypes";

export const NoSelection: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div>
      <p>{message}</p>
    </div>
  );
};

export const ErrorMessage: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className="error-message">
      <p>{message}</p>
    </div>
  );
};

export const TextBlock: React.FC<{ block: string }> = ({ block }) => {
  return <p className={"goal-prompt"}>{block}</p>;
};

export const AlertBlock: React.FC<{ block: string }> = ({ block }) => {
  return <div className="goal-alert">{block}</div>;
};

export const FormTitle: React.FC<{ title: string }> = ({ title }) => {
  return (
    <div className="goal-form-header-block">
      <span className="form-step-title">{title}</span>
    </div>
  );
};

export const GoalUser: React.FC<{
  user: { firstName: string; lastName: string };
}> = ({ user }) => {
  const { t } = useContext(TMDataContext);
  return (
    <div className="goal-form-prefilled-row">
      <span className="goal-input-area-title">
        {t("views.goals.headings.user")}
      </span>
      <span>
        {user.firstName} {user.lastName}
      </span>
    </div>
  );
};

export const Goaltype: React.FC<{
  type: { id: number; label: string };
}> = ({ type }) => {
  const { t } = useContext(TMDataContext);
  return (
    <div className="goal-form-prefilled-row">
      <span className="goal-input-area-title">
        {t("views.goals.headings.type")}
      </span>
      <span>{type.label}</span>
    </div>
  );
};

export const GoalFormNavigationButton: React.FC<{
  title: string;
  allow: boolean;
  handleClick: (e: any) => void;
}> = ({ title, handleClick, allow }) => {
  const { t } = useContext(TMDataContext);
  const handlePreClick = (e) => {
    e.preventDefault();
    handleClick(e);
  };

  const styling = (title) => {
    let style;
    switch (title) {
      case "cancel":
        style = "btn goal-btn btn-danger";
        break;
      case "save":
        style = "btn btn-success goal-btn";
        break;
      case "reload_templates":
        style = "btn btn-info goal-btn goal-reload";
        break;
      default:
        style = "btn btn-success goal-btn";
        break;
    }
    return style;
  };

  const handleVoidClick = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <button
        className={styling(title)}
        style={allow ? null : { backgroundColor: "grey" }}
        onClick={allow ? handlePreClick : handleVoidClick}
        value={title}
      >
        {t(`buttons.${title}`)}
      </button>
    </>
  );
};

export const NumericInput: React.FC<NumericInputShape> = ({
  id,
  state,
  handleValue,
}) => {
  return (
    <input
      id={id}
      type="text"
      onChange={(e) => handleValue(e.target.value)}
      value={state == null ? "" : state}
      className="goal-input-number-field"
    />
  );
};

export const BasicNumericInput: React.FC<BasicNumericInputShape> = ({
  maxValue,
  minValue,
  handleValue,
  returnedValue,
  inputId,
  className,
}) => {
  return (
    <input
      type="number"
      id={inputId}
      onChange={handleValue}
      value={returnedValue == null ? "" : returnedValue}
      className={className}
      min={minValue}
      max={maxValue}
      style={{ marginRight: "5px", marginLeft: "5px" }}
    />
  );
};
